import React, { useReducer, createContext, useContext, useMemo } from 'react';

import {
	type PerformanceInsightsActionType,
	performanceInsightsReducer,
	buildInitialPerformanceInsightsStore,
	type PerformanceInsightsStoreType,
} from './performanceInsightsReducer.ts';

const PerformanceInsightsContext = createContext<{
	state: PerformanceInsightsStoreType;
	dispatch: React.Dispatch<PerformanceInsightsActionType>;
}>({
	state: buildInitialPerformanceInsightsStore(),
	dispatch: () => null,
});

export const PerformanceInsightsStoreProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const [state, dispatch] = useReducer(
		performanceInsightsReducer,
		buildInitialPerformanceInsightsStore(),
	);

	const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);

	return (
		<PerformanceInsightsContext.Provider value={contextValue}>
			{children}
		</PerformanceInsightsContext.Provider>
	);
};

export const usePerformanceInsightsStore = () => useContext(PerformanceInsightsContext);
